/** 海报页(1) + 聊天气泡页(2) 多语言文案 */
const languageTextObj = {
  "ar": {
    "share_land_01": "مجموعة ضخمة من المسلسلات القصيرة الأكثر رواجًا، استمتع بالمشاهدة!",
    "share_land_02": "فتح",
    "share_land_03": " شاهد الآن",
    "share_land_04": "شاهد مجانًا الآن",
    "share_land_05": "أول {s} حلقات",
    "share_land_06": "وجدتُ كنزًا! هذا المسلسل مُمتع للغاية!",
    "share_land_07": "حلقة واحدة تكفي لتدمنه، ولن تستطيع التوقف!",
    "share_land_08": "لن تتمكن من توقع النهاية أبدًا، جرّب بنفسك!",
    "share_land_09": "هذا التحوّل مذهل! شاهد الآن!",
    "share_land_10": "هذا من أكثر المسلسلات التي أحببتها مؤخرًا، أشاركه معك~",
    "share_land_11": "يتناول بشكل رئيسي:",
    "share_land_12": "تمت إزالة هذا المسلسل",
    "share_land_13": "نظرًا لتعديلات حقوق النشر أو تحسين المحتوى، لا يمكن مشاهدة هذا المسلسل حاليًا",
    "share_land_14": "عرض مسلسلات قصيرة رائجة أخرى"
  },
  "cn": {
    "share_land_01": "海量热门短剧，沉浸观赏",
    "share_land_02": "打开",
    "share_land_03": "立即观看",
    "share_land_04": "立即免费观看",
    "share_land_05": "前{s}集",
    "share_land_06": "挖到宝了，这剧看完直呼过瘾！",
    "share_land_07": "一集入坑，根本停不下来",
    "share_land_08": "绝对猜不到本剧的结局，不信试试！",
    "share_land_09": "这反转绝了！速看！",
    "share_land_10": "这是我最近超喜欢的剧，分享给你~",
    "share_land_11": "主要讲述了:",
    "share_land_12": "该剧集已下线",
    "share_land_13": "因版权调整或内容优化等原因，此剧集暂时无法观看",
    "share_land_14": "查看其他热门短剧"
  },
  "de": {
    "share_land_01": "Riesige Auswahl an Top-Serien – Tauch ein!",
    "share_land_02": "Öffnen",
    "share_land_03": "Jetzt ansehen",
    "share_land_04": "Jetzt gratis ansehen",
    "share_land_05": "Erste {s} Folgen",
    "share_land_06": "Was für ein Fund! Diese Serie ist der Wahnsinn!",
    "share_land_07": "Schon nach einer Folge süchtig – man kann nicht aufhören!",
    "share_land_08": "Das Ende errätst du nie. Probier’s aus!",
    "share_land_09": "Was für ein Twist! Musst du sehen!",
    "share_land_10": "Meine aktuelle Lieblingsserie, die musst du sehen! ~",
    "share_land_11": "Handlung:",
    "share_land_12": "Diese Serie ist nicht mehr verfügbar.",
    "share_land_13": "Aufgrund von Urheberrechtsanpassungen oder Inhaltsoptimierungen ist diese Serie vorübergehend nicht verfügbar.",
    "share_land_14": "Andere Hype-Serien ansehen"
  },
  "en": {
    "share_land_01": "All kinds of dramas here. Immerse yourself!",
    "share_land_02": "Open",
    "share_land_03": "Watch Now",
    "share_land_04": "Watch for Free",
    "share_land_05": "First {s} Episodes",
    "share_land_06": "Hidden gem! This show is a total blast!",
    "share_land_07": "Hooked from episode one. Can't stop!",
    "share_land_08": "You'll never guess the ending! Dare to try?",
    "share_land_09": "What a twist! Watch it now!",
    "share_land_10": "My latest obsession. Sharing it with you~",
    "share_land_11": "Synopsis：",
    "share_land_12": "Unavailable",
    "share_land_13": "This drama is temporarily unavailable due to copyright or content adjustments.",
    "share_land_14": "Other Hot Picks"
  },
  "es": {
    "share_land_01": "Miles de dramas populares, experiencia inmersiva  ",
    "share_land_02": "Abrir  ",
    "share_land_03": "Ver ahora  ",
    "share_land_04": "Ver gratis ",
    "share_land_05": "Primeros {s} episodios  ",
    "share_land_06": "¡Encontré una joya, este drama es adictivo!  ",
    "share_land_07": "Empiezas con uno y no puedes parar  ",
    "share_land_08": "No adivinarás el final, ¡pruébalo!  ",
    "share_land_09": "¡Qué giro tan brutal! ¡Míralo ya!  ",
    "share_land_10": "Es uno de mis dramas favoritos últimamente, te lo comparto~",
    "share_land_11": "Sinopsis:",
    "share_land_12": "Este drama ya no está disponible.",
    "share_land_13": "Este drama no está disponible temporalmente debido a ajustes en los derechos de autor o en el contenido.",
    "share_land_14": "Ver otros dramas populares"
  },
  "fr": {
    "share_land_01": "Des séries populaires en immersion totale",
    "share_land_02": "Ouvrir",
    "share_land_03": "Regarder maintenant",
    "share_land_04": "Regarder gratuitement",
    "share_land_05": "{s} premiers épisodes",
    "share_land_06": "Une vraie pépite — cette série est captivante !",
    "share_land_07": "Accro dès le 1er épisode",
    "share_land_08": "Vous ne devinerez jamais la fin — essayez !",
    "share_land_09": "Ce retournement est incroyable !",
    "share_land_10": "Une série que j’adore, à partager avec vous~",
    "share_land_11": "Il s’agit principalement de :",
    "share_land_12": "Ce drame a été retiré",
    "share_land_13": "Pour cause de droits ou d'optimisation, ce drame n'est pas accessible pour le moment.",
    "share_land_14": "Découvrez d'autres drames"
  },
  "hi": {
    "share_land_01": "ढेरों हिट शो, देखते रहो",
    "share_land_02": "खोलें",
    "share_land_03": "अभी देखें",
    "share_land_04": "अभी मुफ्त देखें",
    "share_land_05": "पहले {s} एपिसोड",
    "share_land_06": "खजाना मिल गया, ये शो देखकर मज़ा आ गया!",
    "share_land_07": "एक एपिसोड में फँसे, रुकना मुश्किल",
    "share_land_08": "अंत नहीं पता चलेगा, देखो तो सही!",
    "share_land_09": "ट्विस्ट कमाल है! जल्दी देखो!",
    "share_land_10": "ये मेरा हालिया फेवरेट शो है, तुम्हें साझा कर रहा हूँ~",
    "share_land_11": "मुख्य कहानी:",
    "share_land_12": "यह ड्रामा हटा दिया गया है",
    "share_land_13": "कॉपीराइट या कंटेंट अपडेट के कारण, यह ड्रामा अभी उपलब्ध नहीं है",
    "share_land_14": "अन्य ट्रेंडिंग ड्रामा देखें"
  },
  "id": {
    "share_land_01": "Ribuan drama populer, tonton sepuasnya",
    "share_land_02": "Buka",
    "share_land_03": "Tonton sekarang",
    "share_land_04": "Tonton gratis sekarang",
    "share_land_05": "{s} episode pertama",
    "share_land_06": "Keren banget, nonton drama ini puas banget!",
    "share_land_07": "Baru nonton satu episode langsung nagih!",
    "share_land_08": "Gak bakalan nebak endingnya, kalau gak percaya coba tonton!",
    "share_land_09": "Plot twist-nya gila banget! Buruan nonton!",
    "share_land_10": "Ini drama favoritku belakangan ini, yuk nonton!",
    "share_land_11": "Sinopsis:",
    "share_land_12": "Episode ini telah dihapus",
    "share_land_13": "Tidak dapat ditonton karena penyesuaian hak cipta atau konten",
    "share_land_14": "Lihat drama populer lainnya"
  },
  "it": {
    "share_land_01": "Tantissimi corti popolari, visione immersiva",
    "share_land_02": "Apri",
    "share_land_03": "Guarda ora",
    "share_land_04": "Guarda gratis subito",
    "share_land_05": "Prime {s} puntate",
    "share_land_06": "Colpo di fortuna, questa serie è pazzesca!",
    "share_land_07": "Ti prende già dal primo episodio",
    "share_land_08": "Finale imprevedibile, prova a indovinare!",
    "share_land_09": "Colpi di scena assurdi! Guarda subito!",
    "share_land_10": "Questa è la mia serie del momento, te la consiglio~",
    "share_land_11": "Sinossi:",
    "share_land_12": "Questa serie non è più disponibile",
    "share_land_13": "Per motivi di licenza o aggiornamenti dei contenuti, questa serie non è temporaneamente disponibile",
    "share_land_14": "Scopri altre mini-serie popolari"
  },
  "ja": {
    "share_land_01": "人気ドラマが盛りだくさん、最高の視聴体験",
    "share_land_02": "開く",
    "share_land_03": "今すぐ視聴",
    "share_land_04": "今すぐ無料視聴",
    "share_land_05": "第{s}話まで",
    "share_land_06": "大当たり！見終わったら大満足間違いなし！",
    "share_land_07": "1話でハマる、止まらない面白さ",
    "share_land_08": "予測できない結末、ぜひご視聴を！",
    "share_land_09": "このどんでん返しはヤバい！今すぐチェック！",
    "share_land_10": "最近ハマってる作品だよ、ぜひ見てみて～",
    "share_land_11": "あらすじ：",
    "share_land_12": "この作品は配信終了しました",
    "share_land_13": "権利関係の調整または内容の最適化などにより、現在この作品はご視聴いただけません",
    "share_land_14": "他の人気ドラマを見る"
  },
  "ko": {
    "share_land_01": "다양한 인기 단편 드라마, 몰입해서 감상하세요.",
    "share_land_02": "열기",
    "share_land_03": "바로 보기",
    "share_land_04": "지금 바로 무료 관람",
    "share_land_05": "앞 {s}화",
    "share_land_06": "보물 발견! 이 드라마 보고 나니 완전 꿀잼!",
    "share_land_07": "한 화만 봐도 빠져든다, 멈출 수가 없어!",
    "share_land_08": "이 드라마 결말은 절대 예상 못함, 안 믿으면 직접 확인해 보세요!",
    "share_land_09": "반전 대박! 빨리 보기!",
    "share_land_10": "요즘 제가 엄청 좋아하는 드라마, 공유해 줄게요~",
    "share_land_11": "줄거리:",
    "share_land_12": "해당 작품은 서비스가 종료되었습니다.",
    "share_land_13": "저작권 조정 또는 콘텐츠 최적화 등의 사유로 현재 시청이 불가능합니다.",
    "share_land_14": "다른 인기 숏드라마 보러 가기"
  },
  "ms": {
    "share_land_01": "Drama pendek popular melimpah, tontonan mendalam",
    "share_land_02": "Buka",
    "share_land_03": "Tonton sekarang",
    "share_land_04": "Tonton percuma sekarang",
    "share_land_05": "{s} episod pertama",
    "share_land_06": "Jumpa karya hebat, drama ini memang memuaskan hati!",
    "share_land_07": "Tengok satu episod terus terpikat, memang tak boleh berhenti.",
    "share_land_08": "Pasti tak boleh teka penamat drama ini, tak percaya jom cuba!",
    "share_land_09": "Pusingan plot ini memang hebat! Tonton segera!",
    "share_land_10": " Ini drama paling saya suka kebelakangan ini, kongsi dengan anda~",
    "share_land_11": "Ringkasan Cerita:",
    "share_land_12": "Drama ini telah ditanggalkan",
    "share_land_13": "Maaf, drama ini tidak dapat ditonton buat sementara waktu atas faktor hak cipta atau kemas kini kandungan.",
    "share_land_14": "Tonton drama popular lain"
  },
  "pt": {
    "share_land_01": "Muitos curtas populares para você curtir imersivamente.",
    "share_land_02": "Abrir",
    "share_land_03": "Assistir agora",
    "share_land_04": "Assistir grátis agora",
    "share_land_05": "Primeiros {s} episódios",
    "share_land_06": "Que descoberta incrível! Esse drama é muito bom!",
    "share_land_07": "Um episódio e já não consigo parar de assistir.",
    "share_land_08": "Nunca vai adivinhar o final. Aposte?",
    "share_land_09": "Que reviravolta incrível! Corre para assistir!",
    "share_land_10": "Esse é o meu drama favorito no momento, compartilhando com você~",
    "share_land_11": "Principalmente sobre:",
    "share_land_12": "Esta série foi removida do catálogo",
    "share_land_13": "Devido a ajustes de direitos autorais ou otimizações de conteúdo, esta série está temporariamente indisponível.",
    "share_land_14": "Confira outras séries curtas em alta"
  },
  "th": {
    "share_land_01": "ละครสั้นฮิตเพียบ ดูเพลินเต็มอารมณ์",
    "share_land_02": "เปิด",
    "share_land_03": "รับชมทันที",
    "share_land_04": "รับชมฟรีทันที",
    "share_land_05": "{s} ตอนแรก",
    "share_land_06": "เจอของดีแล้ว ดูจบแล้วฟินสุด ๆ",
    "share_land_07": "ดูตอนแรกก็ติด หยุดไม่ได้เลย",
    "share_land_08": "เดาไม่ออกแน่นอน ไม่เชื่อก็ลองดูสิ",
    "share_land_09": "หักมุมโคตรพีคอ่ะ รีบมาดูเลย",
    "share_land_10": "ช่วงนี้ชอบเรื่องนี้มากที่สุด แชร์ให้คุณนะ",
    "share_land_11": "เนื้อเรื่องหลักคือ:",
    "share_land_12": "ซีรีส์นี้ถูกนำออกแล้ว",
    "share_land_13": "กำลังปรับลิขสิทธิ์หรืออัปเดตเนื้อหา จึงยังไม่สามารถรับชมได้ในตอนนี้",
    "share_land_14": "ไปดูซีรีส์สั้นอื่นกันเลย"
  },
  "tr": {
    "share_land_01": "Binlerce popüler kısa dizi, sınırsız izleme keyfi",
    "share_land_02": "Aç",
    "share_land_03": "Hemen İzle",
    "share_land_04": "Şimdi Ücretsiz İzle",
    "share_land_05": "İlk {s} bölüm",
    "share_land_06": "Bakmaya doyamadım, sanki bir define bulmuşum gibi!",
    "share_land_07": "Bağımlılık yaptı, bir bölümü bitince duramıyorsun!",
    "share_land_08": "Dizinin sonunu asla tahmin edemezsin, yoksa dene!",
    "share_land_09": "Twist efsane! Hemen izle!",
    "share_land_10": "Son zamanlarda en sevdiğim dizi, seninle paylaşmak istedim!",
    "share_land_11": "Ana konusu:",
    "share_land_12": "Dizi yayından kaldırıldı",
    "share_land_13": "Telif hakkı düzenlemeleri veya içerik düzenleme gibi nedenlerle bu dizi şu anda izlenememektedir.",
    "share_land_14": "Diğer popüler dizilere göz atın"
  },
  "vi": {
    "share_land_01": "Nhiều phim hot, xem cực đã!",
    "share_land_02": "Mở",
    "share_land_03": "Xem ngay",
    "share_land_04": "Xem miễn phí ngay",
    "share_land_05": "{s} tập đầu",
    "share_land_06": "Phim hay cực, xem là mê!",
    "share_land_07": "Xem 1 tập là nghiện!",
    "share_land_08": "Không đoán được kết đâu!",
    "share_land_09": "Twist cực gắt, xem ngay!",
    "share_land_10": "Phim mình rất thích, chia sẻ bạn",
    "share_land_11": "Nội dung chính: ",
    "share_land_12": "Bộ phim này đã gỡ!",
    "share_land_13": "Do điều chỉnh bản quyền hoặc tối ưu nội dung, bộ phim tạm thời không thể xem.",
    "share_land_14": "Xem các bộ phim hot khác."
  },
  "zh": {
    "share_land_01": "海量熱門短劇，沉浸觀賞",
    "share_land_02": " 開啟",
    "share_land_03": "立即觀看",
    "share_land_04": "立即免費觀看",
    "share_land_05": "前 {s} 集",
    "share_land_06": "挖到寶了，這劇看完直呼過癮！",
    "share_land_07": "一集入坑，根本停不下來",
    "share_land_08": "絕對猜不到這部劇的結局，不信試試！",
    "share_land_09": "這反轉絕了！快看！",
    "share_land_10": "這是我最近超喜歡的劇，分享給你～",
    "share_land_11": "主要講述了：",
    "share_land_12": "該劇集已下線",
    "share_land_13": "因版權調整或內容優化等原因，此劇集暫時無法觀看",
    "share_land_14": "查看其他熱門短劇"
  }
}


export type LangBundle = (typeof languageTextObj)[keyof typeof languageTextObj];

/** 接口 locale（如 zh_CN）→ 文案 bundle key（如 cn），与 locales LANG_CONFIG 一致 */
const API_LOCALE_TO_BUNDLE_KEY: Record<string, keyof typeof languageTextObj> = {
  zh_cn: 'cn',
  ar_ae: 'ar',
  de_de: 'de',
  en_us: 'en',
  es_es: 'es',
  fr_fr: 'fr',
  hi_in: 'hi',
  id_id: 'id',
  it_it: 'it',
  ja_jp: 'ja',
  ko_kr: 'ko',
  ms_my: 'ms',
  pt_br: 'pt',
  th_th: 'th',
  tr_tr: 'tr',
  vi_vn: 'vi',
  zh_tw: 'zh',
};

function resolveBundleLangKey(
  langCode: string | undefined
): keyof typeof languageTextObj {
  const raw = (langCode && String(langCode).trim().toLowerCase()) || 'en';
  const normalized = raw.replace(/-/g, '_');

  if (normalized in languageTextObj) {
    return normalized as keyof typeof languageTextObj;
  }
  if (normalized in API_LOCALE_TO_BUNDLE_KEY) {
    return API_LOCALE_TO_BUNDLE_KEY[normalized];
  }
  return 'en';
}

export function getLangBundle(langCode: string | undefined): LangBundle {
  const key = resolveBundleLangKey(langCode);
  return languageTextObj[key] || languageTextObj.en;
}

const teaserKeys = [
  'share_land_06',
  'share_land_07',
  'share_land_08',
  'share_land_09',
  'share_land_10',
] as const;

export function pickRandomTeaser(bundle: LangBundle) {
  const key = teaserKeys[Math.floor(Math.random() * teaserKeys.length)];
  return bundle[key] || '';
}
